(function () {

    const onSort = function (url) {
        const entriesInGroup = document.querySelectorAll('[data-entry-sortable="' + url + '"]');
        const keys = [];
        for (let i = 0; i < entriesInGroup.length; i++) {
            keys.push(entriesInGroup[i].getAttribute('data-entry-sortable-id'));
        }
        fetch(url, {
            method: 'POST',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]')['content']
            },
            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: JSON.stringify({keys: keys})
        })
            .catch(function (err) {
                console.error(err);
            });
    };

    const appendNumber = function (parent) {
        const lineHeight = 20;
        const numberElement = document.createElement('div');
        numberElement.innerHTML = 2;
        numberElement.setAttribute('data-entry-sortable-number', '');
        numberElement.style.width = lineHeight + 'px';
        numberElement.style.height = lineHeight + 'px';
        numberElement.style.lineHeight = lineHeight + 'px';
        numberElement.style.position = 'absolute';
        numberElement.style.left = 2 + 'px';
        numberElement.style.top = 2 + 'px';
        numberElement.style.background = 'rgba(255,255,255,0.5)';
        numberElement.style.color = 'black';
        numberElement.style.textAlign = 'center';
        numberElement.style.borderRadius = '50%';
        numberElement.style.fontSize = '0.75rem';
        parent.appendChild(numberElement);
    };

    const setNumbers = function (url) {
        const entries = document.querySelectorAll('[data-entry-sortable="' + url + '"]');
        for (let i = 0; i < entries.length; i++) {
            entries[i].querySelector('[data-entry-sortable-number]').innerHTML = i + 1;
        }
    };

    const startSort = function (e) {
        e.preventDefault();
        const entry = e.currentTarget;
        const url = entry.getAttribute('data-entry-sortable');
        const entriesInGroup = document.querySelectorAll('[data-entry-sortable="' + url + '"]');
        const map = [];
        let srcIndex = 0;

        for (let i = 0; i < entriesInGroup.length; i++) {
            if (entriesInGroup[i] === entry) {
                srcIndex = i;
            }
            map.push(entriesInGroup[i].getBoundingClientRect());
        }
        map.push({top: map[map.length - 1].top, left: map[map.length - 1].left + map[map.length - 1].width});

        const entryClientRect = entry.getBoundingClientRect();
        // append movable entry
        let dragged = false;
        const draggableNode = entry.cloneNode();
        draggableNode.innerHTML = entry.innerHTML;
        draggableNode.style.width = entryClientRect.width + 'px';
        draggableNode.style.height = entryClientRect.height + 'px';
        draggableNode.style.display = 'block';
        draggableNode.style.position = 'fixed';
        draggableNode.style.top = entryClientRect.top + 'px';
        draggableNode.style.left = entryClientRect.left + 'px';
        draggableNode.style.cursor = 'pointer';
        draggableNode.style.zIndex = 2;
        draggableNode.style.boxShadow = '0px 0px 4px rgba(0,0,0,1)';


        const arrowElement = document.createElement('div');
        arrowElement.innerHTML = '<svg width="24px" height="24px" viewBox="0 0 24 24" style="display:block"><polygon fill="#00aeff" points="18.066,12 18.066,0 5.934,0 5.934,12 0,12 12,24 24,12 "/></svg>';
        arrowElement.width = 48 + 'px';
        arrowElement.height = 48 + 'px';
        arrowElement.style.position = 'fixed';
        arrowElement.style.zIndex = 1;
        arrowElement.style.transform = 'translate(-50%, -100%)';
        arrowElement.style.transition = 'top 0.4s, left 0.4s';

        const offset = {x: e.clientX - entryClientRect.left, y: e.clientY - entryClientRect.top};

        const onMouseMove = function (e) {
            if (!dragged) {
                document.body.appendChild(draggableNode);
                document.body.appendChild(arrowElement);
            }
            dragged = true;
            draggableNode.style.top = (e.clientY - offset.y) + 'px';
            draggableNode.style.left = (e.clientX - offset.x) + 'px';

            let dstIndex = map.length;
            for (let i = 0; i < map.length; i++) {
                dstIndex = i;
                if (map[i].top + map[i].height > e.clientY - offset.y && map[i].left + map[i].width > e.clientX - offset.x) {
                    break;
                }
            }
            arrowElement.style.top = map[dstIndex].top + 'px';
            arrowElement.style.left = map[dstIndex].left + 'px';
        };

        const onMouseUp = function (e) {
            entry.style.opacity = 1;
            window.removeEventListener('mousemove', onMouseMove);
            window.removeEventListener('mouseup', onMouseUp);
            if (!!dragged) {
                draggableNode.parentNode.removeChild(arrowElement);
                draggableNode.parentNode.removeChild(draggableNode);
                let dstIndex = 0;
                for (let i = 0; i < map.length; i++) {
                    dstIndex = i;
                    if (map[i].top + map[i].height > e.clientY - offset.y && map[i].left + map[i].width > e.clientX - offset.x) {
                        break;
                    }
                }
                if (srcIndex !== dstIndex) {
                    let pivotNode;
                    if (dstIndex === entriesInGroup.length) {
                        entry.parentNode.append(entry);
                    } else {
                        pivotNode = entriesInGroup[dstIndex];
                        pivotNode.parentNode.insertBefore(entry, pivotNode);
                    }
                    setNumbers(url);
                    onSort(url);
                }
                e.preventDefault();
                return false;
            }
        };
        window.addEventListener('mousemove', onMouseMove);
        window.addEventListener('mouseup', onMouseUp);
        entry.style.opacity = '0.5';
    };


    const init = function (list) {
        const entries = list.querySelectorAll('[data-entry-sortable]');
        const urls = {};
        for (let i = 0; i < entries.length; i++) {
            //console.log(entries[i].getAttribute('[data-entry-sortable]'));
            urls[entries[i].getAttribute('data-entry-sortable')] = 1;
            entries[i].addEventListener('mousedown', startSort);
            appendNumber(entries[i]);
        }
        for (let p in urls) {
            setNumbers(p);
        }
    };

    window.addEventListener('load', function(){
        document.querySelectorAll('[data-entry-sortable-list]').forEach(init);
    });

})();
